import React from 'react';
import Link from '../../resolvers/Link';
import classNames from 'clsx';
import Arrow from '@/assets/arrow.svg';
import DribbbleLogo from '@/assets/dribbble-logo.svg';

export default function Button({ className, button, children, ...props }) {
  const btnClass =
    'group inline-flex items-center justify-center font-bold text-dark-500 rounded-lg transition-colors whitespace-nowrap ' +
      {
        arrow: `flex items-center gap-2 px-0 py-2`,
        button: `bg-gradient text-white py-2.5 px-5`,
        light: `bg-blue-50 text-blue-500 hover:bg-blue-100 py-4 px-7`,
        yellow: `bg-yellow-500 text-black hover:bg-yellow-700 py-4 px-7`,
        dribbble: `sm:py-6 sm:px-10 bg-dribbble-500 text-white hover:bg-dribbble-600 flex sm:gap-3.5 items-center px-7`,
      }[button?.variant] || 'link';

  const isHref = button?.url?.startsWith('#');

  const scrollTo = (id) => {
    document.querySelector(id).scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  return (
    <>
      {button?.url ? (
        <>
          {isHref ? (
            <button
              onClick={() => scrollTo(button?.url)}
              className={classNames(btnClass, className)}
              {...props}>
              <ButtonChildren button={button}>{children}</ButtonChildren>
            </button>
          ) : (
            <Link
              to={button?.url}
              className={classNames(btnClass, className)}
              {...props}>
              <ButtonChildren button={button}>{children}</ButtonChildren>
            </Link>
          )}
        </>
      ) : (
        <button className={classNames(btnClass, className)} {...props}>
          <ButtonChildren button={button}>{children}</ButtonChildren>
        </button>
      )}
    </>
  );
}

const ButtonChildren = ({ button, children }) => {
  return (
    <>
      {button?.variant === 'dribbble' && <DribbbleLogo />}
      {children}
      {button?.variant === 'arrow' && (
        <Arrow className='transition-transform group-hover:rotate-45' />
      )}
    </>
  );
};
